export const SET_TEXT = 'TEXT_EDITOR::SET_TEXT';

export function setText(text) {
    return {
        type: SET_TEXT,
        text,
    };
}

export const SET_ALIGNMENT = 'TEXT_EDITOR::SET_ALIGNMENT';

export function setAlignment(alignment) {
    return {
        type: SET_ALIGNMENT,
        alignment,
    };
}

export const SET_FONT = 'TEXT_EDITOR::SET_FONT';

export function setFont(font) {
    return {
        type: SET_FONT,
        font,
    };
}

export const TOGGLE_BOLD = 'TEXT_EDITOR::TOGGLE_BOLD';

export function toggleBold() {
    return {
        type: TOGGLE_BOLD,
    };
}

export const SET_TEXT_COLOR = 'TEXT_EDITOR::SET_TEXT_COLOR';

export function setTextColor(color) {
    return {
        type: SET_TEXT_COLOR,
        color,
    };
}

export const TOGGLE_ITALIC = 'TEXT_EDITOR::TOGGLE_ITALIC';

export function toggleItalic() {
    return {
        type: TOGGLE_ITALIC,
    };
}

export const RESET_TEXT_EDITOR = 'TEXT_EDITOR::RESET_TEXT_EDITOR';

export function resetTextEditor() {
    return {
        type: RESET_TEXT_EDITOR,
    };
}
